export default [
    {
        path: '/',
        redirect:"/home" //首次进入重定向到首页给字体加颜色
    },
    {
        path: '/home',
        component: () => import('../views/Home.vue')
    },
    {
        path: '/auxiliary',
        component: () => import('../views/Auxiliary.vue')
    },
    {
        path: '/productList',
        component: () => import('../views/product/ProductList.vue'),
    },
    {
        path: '/productList/detail',
        component: () => import('../views/product/productDetail/ProductDetail.vue'),
    },
    {
        path: '/news',
        component: () => import('../views/news/News.vue'),
    },
    {
        path: '/news/detail',
        component: () => import('../views/news/Detail.vue'),
    },
    {
        path: '/aboutus',
        component: () => import('../views/AboutUs.vue'),
    },
    {
        path: '/login',
        component: () => import('../views/Login.vue')
    },
    {
        path: '/ggtf',
        component: () => import('../views/Google.vue')
    },
    // {
    //     path: '/ftf',
    //     component: () => import('../views/Facebook.vue')
    // },
    {
        path: '/product/BlackList',
        component: () => import('../views/product/BlackList.vue')
    },
    {
        path: '/product/face',
        component: () => import('../views/product/Face.vue')
    },
    {
        path: '/product/ocr',
        component: () => import('../views/product/Ocr.vue')
    },
    {
        path: '/product/risk',
        component: () => import('../views/product/Risk.vue')
    },
    {
        path: '/product/intelligent',
        component: () => import('../views/product/Intelligent.vue')
    },
    {
        path: '/product/score',
        component: () => import('../views/product/Score.vue')
    },
    {
        path: '/product/score1',
        component: () => import('../views/product/Score1.vue')
    },
    {
        path: '/usecases',
        component: () => import('../views/useCases/UseCases.vue')
    },
    
    {
        path: '/news/detail1',
        component: () => import('../views/news/One.vue'),
    },
    {
        path: '/news/detail2',
        component: () => import('../views/news/Two.vue'),
    },
    {
        path: '/news/detail3',
        component: () => import('../views/news/Three.vue'),

    },
    {
        path: '/news/detail4',
        component: () => import('../views/news/Four.vue'),

    },
    {
        path: '/news/detail5',
        component: () => import('../views/news/Five.vue'),

    },
    {
        path: '/news/detail6',
        component: () => import('../views/news/Six.vue'),
    },
    {
        path: '/company/aboutus',
        component: () => import('../views/company/AboutUs.vue')
    },
    {
        path: '/company/joinus',
        component: () => import('../views/company/JoinUs.vue')
    },
    {
        path: '/contactus',
        component: () => import('../views/contactUs/ContactUs.vue')
    },
    {
        path: '/privacy', //隐私政策
        component: () => import('../views/privacy/Privacy.vue')
    }
]